import styled from '@emotion/styled';

import ValidatingFormSubmitButton from '../../../../../../components/Button/FormSubmitButton';
import CustomSelectField from '../../../../../../components/Form/CustomSelectField';
import { FormComponent } from '../../../../../../components/Form/FormComponent';
import {
  TextAreaInputField,
  TextInputField,
} from '../../../../../../components/Form/FormField';
import {
  BasicInfoDataType,
  BasicInfoInitialValues,
  BasicInfoSchema,
} from '../../../../../../models/profileSettings/basicInformation.model';
import { useAppSelector } from '../../../../../../redux/store';
import { facilityTypes, StateList } from './BasicInformationData';
import useUpdateBasicInformation from '../../../../../../hooks/profilesetting/useUpdateBasicInformation';

const BasicInformation = () => {
  const { updateBasicInfo, loading } = useUpdateBasicInformation();
  const { authData } = useAppSelector((state) => state.auth);

  const handleSubmit = (values: BasicInfoDataType) => {
    const updatedValues = { ...values };
    console.log(updatedValues);
    updateBasicInfo(updatedValues);
  };

  let dynamicBasicInfoInitialValues = BasicInfoInitialValues;
  if (authData?.isVerified) {
    dynamicBasicInfoInitialValues = {
      institutionName: authData.institutionName ?? '',
      street: authData.street ?? '',
      localGovernment: authData.localGovernment ?? '',
      facilityType: authData.facilityType ?? '',
      email: authData.email ?? '',
      state: authData.state ?? '',
      country: authData.country ?? '',
      bio: authData.bio ?? '',
      address: authData.address ?? '',
    };
  }

  return (
    <FormComponent
      initialValues={dynamicBasicInfoInitialValues}
      schema={BasicInfoSchema}
      onSubmit={handleSubmit}
    >
      <FieldGroups>
        <TextInputField
          label="Institution Name"
          name="institutionName"
          type="text"
          placeholder=""
          read={true}
          className="read"
        />

        <TextInputField
          label="Email Address"
          name="email"
          type="text"
          placeholder=""
          read={true}
          className="read"
        />
      </FieldGroups>

      <FieldGroups>
        <TextInputField label="Address" name="street" type="text" />

        <CustomSelectField
          label="Facility Type"
          name="facilityType"
          id="facilityType"
          optionData={facilityTypes}
        />
      </FieldGroups>

      <FieldGroups>
        <TextInputField label="Country" name="country" type="text" />

        <CustomSelectField
          label="State"
          name="state"
          id="state"
          optionData={StateList.map(
            (data: Record<string, string>, index) => data.state
          )}
        />
      </FieldGroups>

      <FieldGroups>
        <TextInputField label="LG" name="localGovernment" type="text" />
        <TextAreaInputField
          label="Bio"
          name="bio"
          type="text"
          className="spanTwo"
        />
      </FieldGroups>

      <FieldGroups className="submit-btn">
        <ValidatingFormSubmitButton className="small" loading={loading}>
          Save
        </ValidatingFormSubmitButton>
      </FieldGroups>
    </FormComponent>
  );
};

const FieldGroups = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  &.three-col {
    grid-template-columns: 1fr 1fr 1fr;
  }

  &.submit-btn {
    display: flex;

    & > * {
      margin-left: auto;
    }
  }

  @media (max-width: 884px) {
    &,
    &.three-col {
      grid-template-columns: 1fr;
    }
  }
`;

export default BasicInformation;
